import * as t from 'io-ts';
export const UTMParams = t.partial({
    utmCampaign: t.string,
    utmContent: t.string,
    utmMedium: t.string,
    utmSource: t.string,
    utmTerm: t.string,
});
